export enum DocumentStatus {
  NEW = "New",
  EXTRACTIONINPROGRESS = "ExtractionInProgress",
  EXTRACTIONCOMPLETED = "ExtractionCompleted",
  EXTRACTIONERROR = "ExtractionError",
  REWRITEINPROGRESS = "RewriteInProgress",
  REWRITECOMPLETED = "RewriteCompleted",
  EXPORTINPROGRESS = "ExportInProgress",
  EXPORTCOMPLETED = "ExportCompleted",
  EXPORTERROR = "ExportError",
  REWRITEERROR = "RewriteError",
  TAGGINGINPROGRESS = "TaggingInProgress",
  TAGGINGCOMPLETED = "TaggingCompleted",
  TAGGINGERROR = "TaggingError",
  REVIEWINPROGRESS = "ReviewInProgress",
  REVIEWCOMPLETED = "ReviewCompleted",
  APPROVED = "Approved",
  ERROR = "Error",
  REWRITEQUEUED = "RewriteQueued",
  TAGGINGQUEUED = "TaggingQueued",
  FINALIZED = "Finalized",
  FINALIZATIONINPROGRESS = "FinalizationInProgress",
  EXTRACTIONQUEUED = "ExtractionQueued",
  PARTIALREWRITEInPROGRESS = "PartialRewriteInProgress",
  PARTIALREWRITECOMPLETED = "PartialRewriteCompleted",
  PARTIALREWRITEERROR = "PartialRewriteError",
  PARTIALREWRITEQUEUED = "PartialRewriteQueued",
  FINALIZATIONQUEUED = "FinalizationQueued",
  FINALIZATIONERROR = "FinalizationError",
  SIMILARITYSEARCHINPROGRESS = "SimilaritySearchInProgress",
  SIMILARITYSEARCHCOMPLETED = "SimilaritySearchCompleted",
  SIMILARITYSEARCHERROR = "SimilaritySearchError",
  SIMILARITYSEARCHQUEUED = "SimilaritySearchQueued"
}
